// extracted by mini-css-extract-plugin
export var addViewLink = "_r-2";
export var availabilityIcon = "_r-17";
export var availabilitySelectionIcon = "_r-16";
export var backButton = "_r-3";
export var backIcon = "_r-10";
export var conversationCount = "_r-4";
export var dragHandle = "_r-6";
export var dropdown = "_r-f";
export var dropdownIcon = "_r-8";
export var dropdownOption = "_r-7";
export var dropdownTriangle = "_r-e";
export var expand = "_r-g";
export var folder = "_r-j";
export var folderItem = "_r-d";
export var icon = "_r-9";
export var iconRow = "_r-a";
export var image = "_r-b";
export var logo = "_r-c";
export var navContainer = "_r-i";
export var navigationFooter = "_r-h";
export var pageShell = "_r-0";
export var pageShellWms = "_r-1";
export var placeholderAvailable = "_r-12";
export var placeholderBox = "_r-15";
export var placeholderBusy = "_r-14";
export var placeholderUnavailable = "_r-13";
export var profile = "_r-l";
export var profileContainer = "_r-n";
export var profileDropdown = "_r-o";
export var profileImage = "_r-m";
export var profileMain = "_r-p";
export var profileSubtitle = "_r-r";
export var profileTitle = "_r-q";
export var reorderIcon = "_r-s";
export var sentLine = "_r-v";
export var settingsHeader = "_r-t";
export var sidenavTextColor = "_r-z";
export var spamLine = "_r-u";
export var subitemWithTag = "_r-5";
export var supportItems = "_r-k";
export var teamText = "_r-11";
export var viewLine = "_r-y";
export var viewLineButton = "_r-x";
export var viewLineButtons = "_r-w";